import { findInSearchHistory } from '../components/Search/utils/searchHistory/find';
import type { Suggestion } from '../interfaces/suggestions';

// Update suggestions for history status
export const updateSuggestions = (
  history: string[],
  suggestions?: Suggestion[],
) =>
  suggestions
    ?.map((suggestion) => ({
      ...suggestion,
      inHistory: findInSearchHistory(suggestion.name, history),
    }))
    // Reorder for history first
    .sort((a, b) => Number(b.inHistory) - Number(a.inHistory));
